"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Directory/PatientTable/ArchiveProgress.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);


var _format = require('./format');

/* One bar above the table for each running archive or restore of the org
 * (D-61): "Archiving 1,200 patients · 500 done". When one ends, its bar goes
 * and the result notice takes its place. */
const ArchiveProgress = ({ archives }) => {
  if (!archives.length) return null
  return (
    _react2.default.createElement('div', { className: "dir-progress-list", __self: this, __source: {fileName: _jsxFileName, lineNumber: 12}}
      ,  archives.map(a => {
        const label = `${a.Restore ? 'Restoring' : 'Archiving'} ${_format.formatCount.call(void 0, a.Total)} ${a.Total === 1 ? 'patient' : 'patients'}`
        const percent = a.Total > 0 ? Math.min(100, Math.round(a.Done / a.Total * 100)) : 0
        return (
          _react2.default.createElement('div', { key: a.TaskKey, className: "dir-progress", role: "status", __self: this, __source: {fileName: _jsxFileName, lineNumber: 17}}
            , _react2.default.createElement('span', { className: "dir-progress--label", __self: this, __source: {fileName: _jsxFileName, lineNumber: 18}}
              , _react2.default.createElement('b', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 19}},  label ), " · "  ,  _format.formatCount.call(void 0, a.Done) , " done"
            )
            , _react2.default.createElement('div', {
              className: "dir-progress--track",
              role: "progressbar",
              'aria-label': label,
              'aria-valuemin': 0,
              'aria-valuemax': a.Total,
              'aria-valuenow': a.Done, __self: this, __source: {fileName: _jsxFileName, lineNumber: 21}}

              , _react2.default.createElement('div', { className: "dir-progress--fill", style: { width: `${percent}%` }, __self: this, __source: {fileName: _jsxFileName, lineNumber: 29}} )
            )
          )
        )
      })
    )
  )
}

exports. default = ArchiveProgress
